"use strict";

Shopify.theme.animation = {
  init: function () {
    $('[data-scroll-class]').waypoint(function () {
      const animationClass = $(this.element).data('scroll-class');
      $(this.element).addClass('animated').addClass(animationClass);
    }, {
      offset: '70%'
    });
  },
  slideTransition: function ($el, animationName, callback) {
    $el.parents('.flickity-enabled').find('.animated').removeClass('animated ' + animationName);
    $el.addClass('animated').addClass(animationName);
  },
  unload: function ($target) {
    $target.data('scroll-class', '');
  }
};
const deferred = {};
Shopify.theme.asyncView = {
  /**
   * Load the template given by the provided URL into the provided
   * view
   *
   * @param {string} url - The url to load.
   * @param {string} view - The view to load into.
   * @param {object} options - Config options.
   * @param {string} options.hash - A hash of the current page content.
   */
  load: (url, view, options = {}) => {
    let data;

    if (url in deferred) {
      return deferred[url];
    }

    const $deferred = $.Deferred();
    deferred[url] = $deferred;

    if (options.hash) {
      data = sessionStorage.getItem(url);

      if (data) {
        const deserialized = JSON.parse(data);

        if (options.hash === deserialized.options.hash) {
          delete deferred[url];
          return $deferred.resolve(deserialized).promise();
        }
      }
    } // NOTE The $.ajax request has the cache option set to false.
    // This is to prevent certain browsers from returning cached
    // versions of the url we are requesting.
    // See this PR for more info: https://github.com/pixelunion/shopify-asyncview/pull/4


    $.ajax({
      url,
      cache: false,
      data: `view=${view}`,
      dataType: 'html',
      headers: {
        'cache-control': 'no-cache'
      },
      success: response => {
        const el = document.createElement('div');
        el.innerHTML = response;
        const responseOptions = JSON.parse(el.querySelector('[data-options]').innerHTML);
        const htmls = el.querySelectorAll('[data-html]');
        let html = {};

        if (htmls.length === 1 && htmls[0].getAttribute('data-html') === '') {
          html = htmls[0].innerHTML;
        } else {
          for (let i = 0; i < htmls.length; i++) {
            html[htmls[i].getAttribute('data-html')] = htmls[i].innerHTML;
          }
        }

        if (options.hash) {
          try {
            sessionStorage.setItem(url, JSON.stringify({
              options: responseOptions,
              html
            }));
          } catch (error) {
            console.error(error);
          }
        }

        delete deferred[url];
        return $deferred.resolve({
          options: responseOptions,
          html
        });
      },
      error: () => {
        delete deferred[url];
        return $deferred.reject();
      }
    });
    return $deferred.promise();
  }
};

Shopify.theme.addImageDimension = function (imageUrl, size) {
  var insertPosition = imageUrl.lastIndexOf(".");
  return imageUrl.substring(0, insertPosition) + size + imageUrl.substring(insertPosition);
};

Shopify.theme.breadcrumbs = {
  init: function (pages) {
    // Show pagination if number of pages is greater than 1
    if (pages > 1) {
      const breadcrumbSpan = document.querySelector('[data-breadcrumb-text]');
      const currentPage = document.querySelector('.paginate').dataset.currentPage ? document.querySelector('.paginate').dataset.currentPage : 1;
      const totalPages = document.querySelector('.paginate').dataset.paginatePages;
      document.querySelector('.js-breadcrumb-text').classList.remove('is-hidden');
      breadcrumbSpan.innerHTML = `${Shopify.translation.page_text} ${currentPage} ${Shopify.translation.of_text} ${totalPages}`;
    }
  },
  unload: function ($target) {
    document.querySelector('.js-breadcrumb-text').classList.add('is-hidden');
  }
};

Shopify.theme.disclosure = {
  enable: function () {
    const $disclosure = $('[data-disclosure]');
    const $toggle = $('[data-disclosure-toggle]');
    const $disclosureWrap = $('.disclosure__list-wrap');
    const $mobileMenuDisclosureList = $('[data-disclosure-list]'); // Check if current opened menu is offscreen

    function checkOffScreen($openedToggle) {
      if ($openedToggle.siblings('.disclosure__list-wrap').is(':off-right')) {
        $openedToggle.siblings('.disclosure__list-wrap').addClass('disclosure--left');
      }
    }

    function closeDisclosures(ignoreTarget, currentTarget) {
      if (ignoreTarget === true) {
        $toggle.not(currentTarget).removeClass('is-clicked');
        $toggle.not(currentTarget).attr('aria-expanded', 'false');
      } else {
        $toggle.removeClass('is-clicked');
        $toggle.attr('aria-expanded', 'false');
      }

      $disclosureWrap.removeClass('disclosure--left');
    } // Close menus on ESC


    $('body').on('keyup', function (e) {
      if (e.which == '27') {
        closeDisclosures();
      }
    }); // Close menus on hoverout

    $disclosure.on('mouseleave', function (e) {
      closeDisclosures();
    }); // Close menus on hoverout

    $disclosure.find('.disclosure-list__item:last-child').on('focusout', function (e) {
      closeDisclosures();
    }); // On click/focus event for toggling options

    $toggle.on('mouseenter focus', function (e) {
      // Close all other menus
      closeDisclosures(true, this);
      const $target = $(e.currentTarget);
      $target.attr('aria-expanded', 'true').addClass('is-clicked');
      checkOffScreen($target);
    }); // Mobile toggle logic

    $mobileMenuDisclosureList.on('touchstart', function (e) {
      const $target = $(e.currentTarget);
      $target.parents('.disclosure').addClass('is-clicked');
      closeDisclosures(true, this);

      if ($target.hasClass('is-clicked') == false) {
        $target.attr('aria-expanded', 'true').addClass('is-clicked');
        checkOffScreen($target);
      } else {
        $target.attr('aria-expanded', 'false').removeClass('is-clicked');
        $disclosureWrap.removeClass('disclosure--left');
      }
    });
    $mobileMenuDisclosureList.on('focusout', function (e) {
      closeDisclosures(true, this);
    }); // Mobile form submitting

    $mobileMenuDisclosureList.on('change', function (e) {
      if (Shopify.media_queries.medium.matches || !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        const $target = $(e.currentTarget);
        const selectedValue = e.currentTarget.value;
        const disclosureInput = $target.parents('.selectors-form__item').find('[data-disclosure-input]');
        const selectorForm = $target.parents('.selectors-form');

        if (!$target.hasClass('custom-currency')) {
          disclosureInput.val(selectedValue);
          selectorForm.submit();
        } else {
          $target.trigger('click');
        }
      }
    });
  },
  unload: function () {
    $('[data-disclosure]').off();
    $('[data-disclosure-toggle]').off();
    $('.disclosure__list-wrap').off();
  }
};

Shopify.theme.dropdownMenu = function () {
  // Grab menu items
  const menuItems = $('.navbar-link'); // Grab dropdowns

  const dropdowns = $('.navbar-dropdown'); // Grab megamenus

  const megamenus = $('.has-mega-menu'); // Listen for enter key

  menuItems.each(function (index, item) {
    let itemVisited = false;
    $(item).on('keydown', function (e) {
      // Check if enter key
      if (e.which === 13) {
        // Prevent it from going to the link
        if (itemVisited === false) {
          e.preventDefault();
        } // Show dropdown


        $(this).closest('.navbar-item').addClass('show-dropdown'); // Reset itemVisited so that they can visit the link

        itemVisited = true;
      }
    });
    $(item).closest('.navbar-item').on('focusout', function (e) {
      if ($(this).find(e.relatedTarget).length === 0) {
        $(item).closest('.navbar-item').removeClass('show-dropdown');
      }
    });
  }); // Listen for enter key

  dropdowns.each(function (index, item) {
    let itemVisited = false;
    $(item).on('keydown', function (e) {
      // Check if enter key
      if (e.which === 13) {
        // Prevent it from going to the link
        if (itemVisited === false) {
          e.preventDefault();
        }

        if ($(this).find('.has-submenu').length > 0) {
          $(this).addClass('show-nested-dropdown');
        } // Reset itemVisited so that they can visit the link


        itemVisited = true;
      }
    });
  }); // Listen for enter key

  megamenus.each(function (index, item) {
    let itemVisited = false;
    $(item).on('keydown', function (e) {
      // Check if enter key
      if (e.which === 13) {
        // Prevent it from going to the link
        if (itemVisited === false) {
          e.preventDefault();
        } // Show megamenu


        $(this).find('.mega-menu').addClass('mega-menu--show'); // Reset itemVisited so that they can visit the link

        itemVisited = true;
      }
    }); // Hide mega menu on focusout

    $(item).on('focusout', function (e) {
      if ($(item).find(e.relatedTarget).length === 0) {
        $(item).find('.mega-menu').removeClass('mega-menu--show');
      }
    });
  });
};


Shopify.theme.getSectionData = function ($section) {
  const sectionId = $section.attr('id').replace('shopify-section-', '');
  var $dataEl = $section.find('[data-section-data][data-section-id=' + sectionId + ']').first();
  if (!$dataEl) return {}; // Load data from attribute, or innerHTML

  var data = $dataEl.data('section-data') || $dataEl.html();
  try {
    return JSON.parse(data);
  } catch (error) {
    console.warn(`Sections: invalid section data found. ${error.message}`);
    return {};
  }
};

Shopify.theme.infiniteScroll = {
  init: function () {
    this.defaults = {
      grid: '[data-load-more--grid]',
      gridItems: '[data-load-more--grid-item]'
    };
    $('body').off('click', '[data-load-more]').on('click', '[data-load-more]', function (e) {
      e.preventDefault();
      e.stopPropagation();
      const $button = $(this);
      const url = $button.attr('href');
      Shopify.theme.infiniteScroll.loadNextPage(url, $button);
    });
    $('body').on('click', '[data-load-more-infinite]', function (e) {
      $(this).remove(); // Prevent link from going to next page
      e.preventDefault();
      e.stopPropagation();
      Shopify.theme.infiniteScroll.enableInfinite();
      return false;
    });

    this.update();
  },
  update: function (){
    if ($('[data-load-infinite-scroll]').length) {
      Shopify.theme.infiniteScroll.enableInfinite();
    }
  },
  loadNextPage: function (url, $button) {
    $.ajax({
      type: 'GET',
      dataType: 'html',
      url: url,
      beforeSend: function () {
        $button.addClass('is-loading');
      },
      success: data => {
        $button.removeClass('is-loading');
        const thumbnails = $(data).find(this.defaults.gridItems);
        const loadMoreButtonUrl = $(data).find('[data-load-more]').attr('href');
        $('[data-load-more]').attr('href', loadMoreButtonUrl);
        $(this.defaults.grid).first().append(thumbnails); // Initialize product reviews

        Shopify.theme.productReviews.init(); // When there are no additional pages, hide load more button

        if (typeof loadMoreButtonUrl == 'undefined') {
          $('[data-load-more]').addClass('is-hidden');
        }
      },
      error: function (x, t, m) {
        location.replace(location.protocol + '//' + location.host + filterURL);
      }
    });
  },
  enableInfinite: function () {
    var infiniteScroll = new Waypoint.Infinite({
      element: $(this.defaults.grid)[0],
      items: '[data-load-more--grid-item]',
      more: '[data-load-infinite]',
      loadingClass: 'loading-in-progress',
      onBeforePageLoad: function () {
        $('[data-load-infinite]').removeClass('is-hidden');
      },
      onAfterPageLoad: function (data) {
        // Initialize product reviews
        Shopify.theme.productReviews.init();
      }
    });
  },
  unload: function () {
    $('[data-load-more]').off();
    $('[data-load-infinite]').off();
  }
};

Shopify.theme.flickityIosFix = function () {
  var touchingCarousel = false,
    touchStartCoords;
  document.body.addEventListener('touchstart', function (e) {
    if (e.target.closest('.flickity-slider')) {
      touchingCarousel = true;
    } else {
      touchingCarousel = false;
      return;
    }

    touchStartCoords = {
      x: e.touches[0].pageX,
      y: e.touches[0].pageY
    };
  });
  document.body.addEventListener('touchmove', function (e) {
    if (!(touchingCarousel && e.cancelable)) {
      return;
    }

    var moveVector = {
      x: e.touches[0].pageX - touchStartCoords.x,
      y: e.touches[0].pageY - touchStartCoords.y
    };
    if (Math.abs(moveVector.x) > 7) e.preventDefault();
  }, {
    passive: false
  });
};

Shopify.theme.loadScript = function (name, url, callback) {
  if (Shopify.theme[name]) {
    callback;
  } else {
    $.ajax({
      url: url,
      dataType: 'script',
      success: callback,
      async: false
    });
  }
};

Shopify.theme.applyMasonry = function (selector, gutterSize) {
  let $galleryWrapper = $('.gallery-type--masonry');

  if ($galleryWrapper.length > 0) {
    $galleryWrapper.imagesLoaded().progress(function () {
      $galleryWrapper.isotope({
        layoutMode: 'masonry',
        itemSelector: selector,
        percentPosition: true,
        masonry: {
          columnWidth: selector,
          gutter: gutterSize
        }
      });
    });
  }
};

Shopify.theme.applyHorizontalMasonry = function () {
  let $galleryWrapper = $('.gallery-type--horizontal-masonry');
  $galleryWrapper.find('.gallery__item').each(function (e) {
    var wrapper = $(this);
    var imgWidth, imgHeight;
    setTimeout(function () {
      imgWidth = wrapper.find('img').width();
      imgHeight = wrapper.find('img').height();
      wrapper.css("flex-basis", imgWidth * 200 / imgHeight);
      wrapper.css("flex-grow", imgWidth * 200 / imgHeight);
      wrapper.find("i").css("padding-bottom", imgHeight / imgWidth * 100 + '%');
    }, 100);
  });
};

Shopify.theme.mobileMenu = {
  init: function () {
    this.$mobileMenuToggle = $('[data-show-mobile-menu]');
    this.$mobileMenuIcon = $('.mobile-menu__toggle-icon');
    this.$mobileDropDownToggle = $('.mobile-menu .close-dropdown');
    $('body').on('click', '[data-show-mobile-menu="false"]', function () {
      Shopify.theme.mobileMenu.open();
    });
    $('body').on('click', '[data-show-mobile-menu="true"]', function () {
      Shopify.theme.mobileMenu.close();
    });

    if (Shopify.theme.jsHeader.enable_sticky === true) {
      this.enableSticky();
    }
  },
  open: function () {
    //Get current position on page
    let currentScrollPosition = window.scrollY;
    $('body').attr('data-current-position', currentScrollPosition); // Calculate height of mobile content area

    let announcementHeight = 0;
    let mobileHeaderHeight = parseInt($('.mobile-header').outerHeight()) + parseInt($('.top-bar').outerHeight());
    if (typeof Shopify.theme.jsAnnouncementBar !== 'undefined' && Shopify.theme.jsAnnouncementBar.enable_sticky) {
      announcementHeight = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();
    }

    $('.mobile-menu').css({
      height: `calc(100vh - ${mobileHeaderHeight + announcementHeight}px)`
    });
    $('.mobile-menu__content').css({
      marginBottom: `${mobileHeaderHeight + announcementHeight}px`
    });
    this.$mobileMenuIcon.addClass('is-active');
    $('[data-show-mobile-menu]').attr('data-show-mobile-menu', true);

    if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
      Shopify.theme.jsAjaxCart.hideMiniCart();
      Shopify.theme.jsAjaxCart.hideDrawer();
    } //Set delay on menu open to get proper page position


    setTimeout(function () {
      $('body').addClass('mobile-menu--opened');
    }, 10);
  },
  close: function () {
    $('body').removeClass('mobile-menu--opened'); // Once mobile menu is closed, return back to previous position on page

    let lastScrollPosition = $('body').data('current-position');
    window.scrollTo(0, lastScrollPosition);
    this.$mobileMenuIcon.removeClass('is-active');
    $('[data-show-mobile-menu]').attr('data-show-mobile-menu', false);
  },
  enableSticky: function () {
    Shopify.theme.jsHeader.disableSticky();
    let $stickyEl = $('#mobile-header');
    let offset = 0;

    if (typeof Shopify.theme.jsAnnouncementBar !== 'undefined' && Shopify.theme.jsAnnouncementBar.enable_sticky) {
      offset = Shopify.theme.jsAnnouncementBar.getAnnouncementHeight();
    }

    $stickyEl.addClass('sticky--enabled');
    $stickyEl.sticky({
      wrapperClassName: 'header-sticky-wrapper',
      zIndex: 40,
      topSpacing: offset
    }).on('sticky-start', () => {
      var headerheight = $('#mobile-header').outerHeight();
      var annoucementHeight = $('.announcement-sticky-wrapper').outerHeight();
      var totalHeight = headerheight + annoucementHeight;
      $stickyEl.parent().parent().find('.search-overlay').addClass('sticky-search').css('top', totalHeight + 'px');
    }).on('sticky-end', () => {
      $stickyEl.parent().parent().find('.search-overlay').removeClass('sticky-search').css('top', '100%'); // Safety timeout for logo width transition which can throw calculated height off

      setTimeout(() => {
        $stickyEl.sticky('update');
      }, 250);
      $stickyEl.find('.sticky-menu-wrapper').removeClass('is-visible');
    });
  },
  disableSticky: function () {
    let $stickyEl = $('#mobile-header');
    $stickyEl.unstick();
    $stickyEl.removeClass('sticky--enabled');
    setTimeout(function () {
      $('.header-sticky-wrapper').css('height', 'auto');
    }, 250);
  },
  unload: function ($section) {
    $('[data-mobilemenu-toggle]').off();
    $('.mobile-menu__toggle-icon').off();
    $('.mobile-menu .close-dropdown').off();
    this.disableSticky();
  }
};

Shopify.money_format = "${{amount}}";

Shopify.formatMoney = function (t, e) {
  function o(t, e) {
    return "undefined" == typeof t ? e : t;
  }

  function i(t, e, i, r) {
    if (e = o(e, 2), i = o(i, ","), r = o(r, "."), isNaN(t) || null == t) return 0;
    t = (t / 100).toFixed(e);
    var n = t.split("."),
      a = n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i),
      s = n[1] ? r + n[1] : "";
    return a + s;
  }

  "string" == typeof t && (t = t.replace(".", ""));
  var r = "",
    n = /\{\{\s*(\w+)\s*\}\}/,
    a = e || this.money_format;

  switch (a.match(n)[1]) {
    case "amount":
      r = i(t, 2);
      break;

    case "amount_no_decimals":
      r = i(t, 0);
      break;

    case "amount_with_comma_separator":
      r = i(t, 2, ".", ",");
      break;

    case "amount_with_apostrophe_separator":
      r = i(t, 2);
      break;

    case "amount_no_decimals_with_comma_separator":
      r = i(t, 0, ".", ",");
      break;

    case "amount_no_decimals_with_space_separator":
      r = i(t, 0, ".", " ");
  }

  return a.replace(n, r);
}

/*============================================================================
Product media controls
==============================================================================*/

Shopify.theme.productMedia = {
  models: [],
  setupMedia: function () {
    const config = {
      // Default control list
      controls: ['zoom-in', 'zoom-out', 'fullscreen'],
      focusOnPlay: false
    };
    $('model-viewer').each(function (index, model) {
      model = new Shopify.ModelViewerUI(model, config);
      Shopify.theme.productMedia.models.push(model);
    });
    $('.product-gallery__model model-viewer').on('mousedown', function () {
      Shopify.theme.productMedia.hideModelIcon(this);
    });
  },
  showModelIcon: function (slide) {
    $(slide).find('.button--poster, .model-icon-button-control').show();
  },
  hideModelIcon: function (slide) {
    $(slide).find('.button--poster, .model-icon-button-control').hide();
  }
};

Shopify.theme.productReviews = {
  init: function () {
    if ($('#shopify-product-reviews').length || $('.shopify-product-reviews-badge').length) {
      SPR.$(document).ready(function () {
        return SPR.registerCallbacks(), SPR.initRatingHandler(), SPR.initDomEls(), SPR.loadProducts(), SPR.loadBadges();
      });
    }
  },
  productReviewScroll: function () {
    if ($('#shopify-product-reviews').length && $('.shopify-product-reviews-badge').length) {
      $('.spr-badge-container').on('click', function () {
        Shopify.theme.scrollToTop('#shopify-product-reviews');
      });
    }
  },
  unload: function () {
    $('.spr-badge-container').off();
  }
};

Shopify.theme.quantityBox = {
  init: function () {
    $('body').on('click', '[data-update-quantity]:not([disabled])', function () {
      Shopify.theme.quantityBox.updateQuantity($(this));
    });
    $('body').on('keyup keydown change', '.quantity-input', function () {
      Shopify.theme.quantityBox.updateQuantity($(this));
    });
  },
  updateQuantityControls: function ($el) {
    const $quantityBox = $el.parents('.product-quantity-box');
    const $input = $('.quantity-input', $quantityBox);
    let val = parseInt($input.val());
    let valMax = 100000000000000000;

    if ($input.attr('max') != null) {
      valMax = $input.attr('max');
    }

    if (val === 1 || val === 0) {
      $('.quantity-minus', $quantityBox).attr('disabled', true);
      $('.quantity-plus', $quantityBox).attr('disabled', false);
    } else if (val >= valMax) {
      $('.quantity-plus', $quantityBox).attr('disabled', true);
      $('.quantity-minus', $quantityBox).attr('disabled', false);
      $input.val(valMax);
    } else {
      $('.quantity-minus', $quantityBox).attr('disabled', false);
      $('.quantity-plus', $quantityBox).attr('disabled', false);
    }
    if(Shopify.theme.jsProduct && Shopify.theme.jsProduct.is_pistol != false)
      Shopify.theme.jsProduct.updateQuantity($input.val());
  },
  updateQuantity: function ($el) {
    const $quantityBox = $el.parents('.product-quantity-box');
    const $input = $('.quantity-input', $quantityBox);
    const lineID = $quantityBox.parents('[data-line-item]').data('line-item');
    let val = parseInt($input.val());
    let valMax = 100000000000000000;
    let valMin = $input.attr('min') || 0;

    if ($input.attr('max') != null) {
      valMax = $input.attr('max');
    }

    if (val < valMin) {
      $input.val(valMin);
      return false;
    } else if (val > valMax) {
      $input.val(valMax);
      return false;
    }

    if ($el.data('update-quantity') === 'plus') {
      // Increase quantity input by one
      if (val < valMax) {
        val++;
        $input.val(val);
      }
    } else if ($el.data('update-quantity') === 'minus') {
      // Decrease quantity by one
      if (val > valMin) {
        val--;
        $input.val(val);
      }
    } // Update quantity if within cart (vs on the product page)


    if ($el.parents('[data-line-item]').length) {
      const lineID = $quantityBox.data('line-item-key');
      Shopify.theme.quantityBox.updateCart(lineID, val);
    } // Call to update quantity controls


    Shopify.theme.quantityBox.updateQuantityControls($el);
  },
  updateCart: function (lineID, quantity) {
    $('.quantity-warning').removeClass('animated bounceIn');
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: `quantity=${quantity}&line=${lineID}`,
      dataType: 'json',
      success: function (cart) {
        let newQuantity = 0;
        let itemsLeftText = '';
        let quantityWarning = $(`[data-line-item="${lineID}"]`).find('.quantity-warning');
        let $quantityBox = $(`[data-line-item="${lineID}"]`).find('.product-quantity-box');
        let $currentDiscount = $('.cart__form').data('currentDiscount'); //check to see if there are correct amount of products in array

        const cartItemsLineID = lineID - 1;

        if (typeof cart.items[cartItemsLineID] !== "undefined") {
          newQuantity = cart.items[cartItemsLineID].quantity;
        }

        for (let i = 0; i < cart.items.length; i++) {
          if (i != cartItemsLineID) {
            if (cart.items[i].id == cart.items[cartItemsLineID].id) {
              newQuantity += cart.items[i].quantity;
            }
          }
        }

        if (quantity > 0 && quantity != newQuantity) {
          //Check if total discount has changed
          if (cart.total_discount <= $currentDiscount) {
            if (newQuantity == 1) {
              itemsLeftText = Shopify.translation.product_count_one;
              quantityWarning.text(`${newQuantity} ${itemsLeftText}`);
              $('.quantity-minus', $quantityBox).attr('disabled', true);
            } else {
              itemsLeftText = Shopify.translation.product_count_other;
              quantityWarning.text(`${newQuantity} ${itemsLeftText}`);
            }
          }
        } //Update total discount value


        $('.cart__form').data('currentDiscount', cart.total_discount); // Apply quantity warning

        quantityWarning.addClass('animated bounceIn');

        if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
          Shopify.theme.jsAjaxCart.updateView();
        }

        if (Shopify.theme.jsCart) {
          Shopify.theme.jsCart.updateView(cart, lineID);
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  unload: function ($target) {
    $('.quantity-input').off();
    $('[data-update-quantity]').off();
  }
};

Shopify.theme.queryParameters = {};

if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');

    if (aKeyValue.length > 1) {
      Shopify.theme.queryParameters[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}

Shopify.theme.responsiveVideo = {
  init: function () {
    // Find youtube iframes
    var $videoIframes = $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]'); // For each iframe, if parent is a responsive video wrapper do nothing
    // If no parent responsive video wrapper, then wrap iframe in responsive video wrapper

    $videoIframes.each(function (index, iframe) {
      // Update selector
      var $iframe = $(iframe);

      if (!$iframe.parents('.plyr__video-wrapper').length && !$iframe.parents('.lazyframe').length) {
        $iframe.wrap('<div class="lazyframe" data-ratio="16:9"></div>');
      }
    });
  }
};

function selectCallback(productEl, product, variant, state) {
  const $product = $(productEl);
  const $notifyForm = $('.product__notify-form', $product);
  const $productForm = $('.product_form, .shopify-product-form', $product);
  const variantInventory = $productForm.data('variant-inventory');
  const $productFormInput = $productForm.find('.quantity-input');
  const $notifyFormInputs = $('.notify_form__inputs');
  const notifyEmail = Shopify.translation.notify_form_email;
  const notifyEmailValue = Shopify.translation.contact_email;
  const notifySend = Shopify.translation.notify_form_send;
  const notifyUrl = $notifyFormInputs.data('url');
  let notifyMessage = '';
  let notifyEmailInput = '';

  if (variant) {
    if (variant.title != null) {
      // Escape variant titles
      const variantTitle = variant.title.replace(/"/g, '&quot;');
      notifyMessage = `${Shopify.translation.email_content}${variantTitle} | ${notifyUrl}?variant=${variant.id}`;
    }
  } else {
    notifyMessage = `${Shopify.translation.email_content} | ${notifyUrl}`;
  }

  if ($notifyFormInputs.hasClass('customer--true')) {
    notifyEmailInput = `<input required type="email" class="notify_email input" name="contact[email]" id="contact[email]" placeholder="${notifyEmail}" value="${Shopify.translation.customer_email}" />`;
  } else {
    notifyEmailInput = `<input required type="email" class="notify_email input" name="contact[email]" id="contact[email]" placeholder="${notifyEmail}" value="${notifyEmailValue}" />`;
  }
    
  const notifyFormHTML = `
    <input type="hidden" name="challenge" value="false" />
    <input type="hidden" name="contact[body]" class="notify_form_message" data-body="${notifyMessage}" value="${notifyMessage}" />
    <div class="field">
      <div class="control">
        ${notifyEmailInput}
      </div>
      <div class="control">
        <input class="action_button button" type="submit" value="${notifySend}" />
      </div>
    </div>`; // Image Variant feature

  if (variant && variant.featured_image && $product.is(':visible')) {
    const $sliders = $('.product-gallery__main, .js-gallery-modal', $product);
    $sliders.each((_index, value) => {
      const $slider = $(value);
      const $sliderInstance = window.Flickity.data(value);
      let index = $(`img[data-image-id=${variant.featured_media.id}]`).data('index');

      if ($slider.is(':visible') && $sliderInstance !== undefined) {
        $sliderInstance.select(index, false, true);
      }
    });
  } // Emits custom event


  const $selectDropdown = $productForm.find('[data-variant-selector]');
  $selectDropdown.trigger('selectedVariantChanged');
  $('.cart-warning', $product).text('');

  if (variant) {
    $('.sku', $product).text(variant.sku);
    $('.notify_form_message', $product).attr('value', `${$('.notify_form_message', $product).data('body')} - ${variant.title}`);
  }

  if (variant && variant.available) {
    const variantWithInventory = {
      ...variant,
      ...(variantInventory ? variantInventory.find(v => v.id === variant.id) || {} : {})
    };

    if (variantWithInventory.inventory_management && variantWithInventory.inventory_quantity > 0) {
      if (Shopify.theme_settings.display_inventory_left) {
        let itemsLeftText = Shopify.translation.product_count_other;

        if (variantWithInventory.inventory_quantity === 1) {
          itemsLeftText = Shopify.translation.product_count_one;
        }

        const inventoryThreshold = Shopify.theme_settings.inventory_threshold;

        if (variantWithInventory.inventory_quantity <= inventoryThreshold) {
          $('.items_left', $product).html(`${variantWithInventory.inventory_quantity} ${itemsLeftText}`);
        } else {
          $('.items_left', $product).html('');
        }
      }

      if (variantWithInventory.inventory_policy === 'deny') {
        $('[data-max-inventory-management]', $product).attr('max', variantWithInventory.inventory_quantity); // Check to see if quantity selector should be disabled based on inventory remaining

        Shopify.theme.quantityBox.updateQuantityControls($productFormInput);
      }
    } else {
      $('.items_left', $product).text('');
      $('[data-max-inventory-management]', $product).removeAttr('max');
    }

    $('.sold_out', $product).text('');
    $('[data-add-to-cart-trigger]', $product).removeClass('disabled').removeAttr('disabled').attr('data-options-unselected', null).find('span:not(.icon)').html($('[data-add-to-cart-trigger]', $product).data('label')); // Initialize shopify payment buttons

    if (Shopify.PaymentButton) {
      Shopify.PaymentButton.init();
    }

    $('.shopify-payment-button', $product).show();
    $('.purchase-details__quantity', $product).show();
    $notifyForm.hide();
    $notifyFormInputs.empty();
    $notifyFormInputs.append(notifyFormHTML);

    if (Shopify.theme.currencyConverter) {
      Shopify.theme.currencyConverter.convertCurrencies();
    }
    document.querySelector('.button--add-to-cart').dataset.label=Shopify.translation.addToCart;
    document.querySelector('.button--add-to-cart .text').textContent=Shopify.translation.addToCart;
  } else {
    const message = variant ? Shopify.translation.soldOut : Shopify.translation.unavailable;
    $('.items_left', $product).text('');
    $('[data-max-inventory-management]', $product).removeAttr('max');
    $('.sold_out', $product).text(message); // If we haven't selected all options, let the add to cart button be enabled

    if (state === 'not-selected') {
      document.querySelector('.button--add-to-cart').dataset.label='Select Variant';
      document.querySelector('.button--add-to-cart .text').textContent='Select Variant';
      $('[data-add-to-cart-trigger]', $product).removeClass('disabled').removeAttr('disabled').attr('data-options-unselected', '').find('span:not(.icon)').text($('[data-add-to-cart-trigger]', $product).data('label'));
      $('[data-add-to-cart-trigger]', $product).removeClass('disabled').removeAttr('disabled').attr('data-options-unselected', '').find('span:not(.icon)').text('Select Variant');
    } else {
      document.querySelector('.button--add-to-cart').dataset.label=message;
      document.querySelector('.button--add-to-cart .text').textContent=message;
      $('[data-add-to-cart-trigger]', $product).addClass('disabled').attr('disabled', 'disabled').attr('data-options-unselected', null).find('span:not(.icon)').text(message);
    }

    $('.shopify-payment-button', $product).hide();
    $('.purchase-details__quantity', $product).hide();
    $notifyForm.hide();
    $notifyFormInputs.empty();

    if (variant && !variant.available) {
      $notifyForm.fadeIn();
      $notifyFormInputs.empty();
      $notifyFormInputs.append(notifyFormHTML);
    }
  }
}

window.selectCallback = selectCallback;

Shopify.theme.predictiveSearch = {
  vars: {
    term: '',
    searchPath: Shopify.routes.search_url,
    displayTimer: ''
  },
  init: function () {
    this.unload();
    $('[data-show-search-trigger], [data-autocomplete-true] input').on('click touchstart', function (e) {
      if (!isScreenSizeLarge()) {
        e.stopPropagation();
        const formType = $(this).closest('form').find('[name="type"]').val();
        const position = $(document).scrollTop();
        Shopify.theme.predictiveSearch.showMobileSearch(formType, position);
      }
    }); // Focus state to display search results

    $('[data-autocomplete-true]').on('focus', function () {
      $(this).parents('[data-autocomplete-true]').find('.search__results-wrapper').show();
    }); // Clicking outside makes the results disappear.

    $(document).on('click focusout', function (e) {
      if (Shopify.media_queries.large.matches) {
        var searchForm = $(e.target).parents('.search-form');

        if (searchForm.length === 0) {
          $('[data-autocomplete-true] .search__results-wrapper').hide().removeClass('results-found');
        }
      }
    }); // Submit wildcard searches

    $("[data-autocomplete-true] form").on("submit", function (e) {
      e.preventDefault();
      const formValue = $(this).find('input[name="q"]').val();
      const cleanFormValue = encodeURI(formValue);
      let searchType = Shopify.theme_settings.search_option;

      if ($(this).find('[name="type"]').length > 0) {
        searchType = $(this).find('[name="type"]').val();
      }

      if (cleanFormValue == null) {
        window.location.href = Shopify.routes.search_url + '?type=' + searchType;
      } else {
        window.location.href = Shopify.theme.predictiveSearch.vars.searchPath + '?type=' + searchType + '&q=' + cleanFormValue + '*';
      }
    });
    $('[data-autocomplete-true] form').each(function () {
      const $this = $(this);
      const input = $this.find('input[name="q"]'); // Adding a list for showing search results.

      const resultWrapper = `
        <div class="search__results-wrapper">
          <h2 class="vertical-search__title">
            ${Shopify.translation.top_suggestions}
          </h2>
          <ul class="search__results"></ul>
        </div>
      `;
      $(resultWrapper).appendTo($this);
      input.attr('autocomplete', 'off').on('input', function () {
        clearTimeout(Shopify.theme.predictiveSearch.vars.displayTimer);

        if ($(this).val().length > 3) {
          Shopify.theme.predictiveSearch.vars.term = $(this).val();
          Shopify.theme.predictiveSearch.getResults(Shopify.theme.predictiveSearch.vars.term, $this);
        } else {
          $('[data-autocomplete-true] .search__results-wrapper').hide().removeClass('results-found');
        }
      });
    });
  },
  getResults: function (term, $this) {
    let searchType = Shopify.theme_settings.search_option;

    if ($this.find('[name="type"]').length > 0) {
      searchType = $this.find('[name="type"]').val();
    }

    jQuery.getJSON("/search/suggest.json", {
      "q": term,
      "resources": {
        "type": searchType,
        "limit": Shopify.theme_settings.search_to_display,
        "options": {
          "unavailable_products": "last",
          "fields": "title,body,variants.title,variants.sku,vendor,product_type,tag"
        }
      }
    }).done(function (response) {
      const suggestions = [response.resources.results.products, response.resources.results.pages, response.resources.results.articles];
      let filteredResults = []; // Store results in array

      $.each(suggestions, function (index, suggestion) {
        if (suggestion !== undefined && suggestion.length > 0) {
          // Ensure suggestion exists
          filteredResults.push(suggestion);
        }
      }); // Display results

      Shopify.theme.predictiveSearch.vars.displayTimer = setTimeout(function () {
        Shopify.theme.predictiveSearch.displayResults(filteredResults[0], $this);
      }, 500);
    });
  },
  displayResults: function (results, $this) {
    const $resultsWrapper = $this.find('.search__results-wrapper');
    const $resultsList = $this.find('.search__results');
    let searchType = Shopify.theme_settings.search_option;
    $resultsWrapper.show();
    $resultsList.empty();

    if ($this.find('[name="type"]').length > 0) {
      searchType = $this.find('[name="type"]').val();
    }

    if (results && results.length > 0) {
      $.each(results, function (index, result) {
        let link = $('<a tabindex="0"></a>').attr('href', result.url);

        if (Shopify.routes.root_url !== '/') {
          link = $('<a tabindex="0"></a>').attr('href', Shopify.routes.root_url + result.url);
        } // if result is a product


        if (result['price']) {
          function formatPrice(price) {
            return '<span class="money">' + Shopify.formatMoney(price, $('body').data('money-format')) + '</span>';
          }

          let itemPrice;

          if (result.available === true) {
            if (result.compare_at_price_max > result.price_max || result.compare_at_price_min > result.price_min) {
              itemPrice = `${formatPrice(result.price)} <span class="was-price">${formatPrice(result.compare_at_price_max)}</span>`;
            } else {
              if (result.price > 0) {
                if (result.price_min != result.price_max) {
                  itemPrice = `${Shopify.translation.from} ${formatPrice(result.price)}`;
                } else {
                  itemPrice = `${formatPrice(result.price)}`;
                }
              } else {
                itemPrice = Shopify.theme_settings.free;
              }
            }
          } else {
            itemPrice = Shopify.translation.soldOut;
          } // If result has image


          if (result['image']) {
            link.append(`<div class="thumbnail"><img class="lazyload transition--${Shopify.theme_settings.image_loading_style}" src="${Shopify.theme.addImageDimension(result['image'], '_300x')}" /></div>`);
          }

          link.append(`<div class="description"><strong>${result.title}</strong><br><span class="item-pricing price">${itemPrice}</span></div>`); // if result is an article
        } else if (result['summary_html']) {
          if (result.image != 'NULL') {
            link.append(`<div class="thumbnail"><img class="lazyload transition--${Shopify.theme_settings.image_loading_style}" src="${Shopify.theme.addImageDimension(result['image'], '_300x')}" /></div>`);
          }

          link.append(`<div class="description"><strong>${result.title}</strong><br><span class="item-description">'${result.summary_html.replace(/(<([^>]+)>)/ig, "").slice(0, 25)}</span></div>`); // if result is a page
        } else if (result['published_at']) {
          link.append(`<div class="description"><strong>${result.title}</strong><br><span class="item-description">${result.body.replace(/(<([^>]+)>)/ig, "").slice(0, 25)}</span></div>`);
        } // Wrap link and append to list


        link.wrap('<li class="item-result"></li>');
        $resultsList.append(link.parent());

        if (Shopify.theme.currencyConverter) {
          Shopify.theme.currencyConverter.init();
        }
      });
      $resultsList.prepend(`<li class="all-results"><span class="see-all"><a href="${this.vars.searchPath}?type=${searchType}&q=${this.vars.term}*"> ${Shopify.translation.all_results} ${Shopify.icons.right_caret}</a></span></li>`);
      $resultsList.parents('.search__results-wrapper').addClass('results-found');
    } else {
      // if no results
      const noResults = `<li class="item-result"><span class="no-results">${Shopify.translation.no_results}</span></li>`;
      $resultsList.append(noResults);
      $resultsList.parents('.search__results-wrapper').removeClass('results-found');
    }

    if ($this.parents('.vertical-header__content').length && Shopify.theme.jsHeader.header_layout === 'vertical') {
      Shopify.theme.predictiveSearch.alignVerticalSearch();
    }

    $resultsList.show();
  },
  showMobileSearch: function (formType, position) {
    $('body').css('max-height', window.innerHeight);
    $('.mobile-search').fadeIn(200);

    if (/iPad|iPhone|iPod/.test(navigator.platform) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
      $('.mobile-search input[data-q]').focus();
    } else {
      //Set delay to ensure focus triggers on android
      setTimeout(function () {
        $('.mobile-search input[data-q]').focus();
      }, 205);
    }

    document.body.style.position = 'fixed';
    document.body.style.top = '-' + position + 'px';
    $('.mobile-search').css('top', position);
    const searchHeight = window.innerHeight - 46; //Full screen height - form height

    $('.mobile-search .search__results-wrapper').css('max-height', searchHeight);

    if (formType) {
      $('.mobile-search [name="type"]').val(formType);
    } else {
      $('.mobile-search [name="type"]').val(Shopify.theme_settings.search_option);
    }

    $('.search-form .close-search').on('click touchstart', function (e) {
      e.preventDefault();
      e.stopPropagation();
      Shopify.theme.predictiveSearch.hideMobileSearch(position);
      $('[data-autocomplete-true] .search__results-wrapper').hide().removeClass('results-found');
    });
    $('.search-form .submit-search').on('click touchstart', function (e) {
      $(this).parents('form').submit();
    });
  },
  hideMobileSearch: function (position) {
    $('body').css('max-height', 'none');
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo(0, position);
    $('.mobile-search').fadeOut(200);
    $('.mobile-search [name="q"]').val('');
    $('body').off('focus', '.search-form .close-search');
    $('body').off('focus', '.search-form .submit-search');
  },
  alignVerticalSearch: function () {
    const $resultsList = $('.header--vertical .search__results');
    const headerWidth = $('.header--vertical').innerWidth();
    $resultsList.parents('.search__results-wrapper').css({
      'position': 'fixed',
      'left': headerWidth,
      'top': '0'
    });
  },
  unload: function () {
    $('body').off('focus', '[data-autocomplete-true] input');
    $('input[name="q"]').off();
    $('[data-dropdown-rel="search"], [data-autocomplete-true] input').off();
    $('.search__results-wrapper').remove();
  }
};

function isScreenSizeLarge() {
  if (Shopify.media_queries.large.matches) {
    return true;
  }
}

Shopify.theme.scrollToTop = function (element, height) {
  // Check if height argument is present
  if (height != undefined) {
    $('html, body').animate({
      scrollTop: $(element).offset().top - height
    }, 1000);
  } else {
    $('html, body').animate({
      scrollTop: $(element).offset().top
    }, 1000);
  }
};

Shopify.theme.handleNewTabLinks = function ($links) {
  if (!$links.length) return;
  $links.each(function (index, link) {
    let href = $(link).attr('href')
    if(Shopify.theme.isExternalLink(href)){
      link.setAttribute('target','_blank')
    }
  })
};

Shopify.theme.isExternalLink = function(link){
  if (link.indexOf("http://") == 0 || link.indexOf("https://") == 0) {
    return true
  }
  return false
};

class ProductCard {
  enableSwatches() {
    if (window.isScreenSizeLarge()) {
      $('body').on('mouseenter', '.swatch span', ({
        currentTarget
      }) => {
        if (currentTarget && $(currentTarget).data('image').indexOf('no-image') === -1) {
          $(currentTarget).parents('.thumbnail').find('.product__imageContainer img:not(.secondary)').attr('src', $(currentTarget).data('image'));
          $(currentTarget).parents('.thumbnail').find('.product__imageContainer img:not(.secondary)').attr('srcset', $(currentTarget).data('image'));
        }
      });
    }
  }

  showVariantImage() {
    if (window.isScreenSizeLarge()) {
      $('body').on('mouseenter', '.has-secondary-image-swap', ({
        currentTarget
      }) => {
        const $thumbnailImage = $(currentTarget).find('.product-image__wrapper img');
        const $thumbnailVideo = $(currentTarget).find('.product-image__wrapper .video-on-hover');

        if ($thumbnailImage) {
          $thumbnailImage.toggleClass('swap--visible');
        }

        if ($thumbnailVideo) {
          $thumbnailVideo.toggleClass('swap--visible');
          Shopify.theme.video.enableVideoOnHover($(currentTarget));
        }
      });
      $('body').on('mouseleave', '.has-secondary-image-swap', ({
        currentTarget
      }) => {
        const $thumbnailImage = $(currentTarget).find('.product-image__wrapper img');
        const $thumbnailVideo = $(currentTarget).find('.product-image__wrapper .video-on-hover');

        if ($thumbnailImage) {
          $thumbnailImage.toggleClass('swap--visible');
        }

        if ($thumbnailVideo) {
          $thumbnailVideo.toggleClass('swap--visible');
          Shopify.theme.video.disableVideoOnHover($(currentTarget));
        }
      });
    }
  }

  showQuickShop() {
    // EVENT - click on quick-shop
    $('body').on('click', '.js-quick-shop-link', e => {
      e.preventDefault();
      const $currentTarget = $(e.currentTarget);
      $currentTarget.addClass('is-loading')
      Shopify.theme.jsProductClass.load($currentTarget.data('url')).then(({
        html
      }) => {
        $('.js-quick-shop').html(html.content);
        $('.js-quick-shop .js-product_section').addClass('quickshop');

        if (!$('.fancybox-active').length) {
          $.fancybox.open($('.js-quick-shop'), {
            baseClass: `quick-shop__lightbox product-${$currentTarget.data('id')}`,
            hash: false,
            infobar: false,
            toolbar: false,
            loop: true,
            smallBtn: true,
            touch: false,
            video: {
              autoStart: false
            },
            mobile: {
              preventCaptionOverlap: false,
              toolbar: true
            },
            beforeShow: () => {
              let currentScrollPosition = window.scrollY;
              $('body').attr('data-current-position', currentScrollPosition);
              $('body').addClass('mobile-menu--opened');
            },
            afterShow: (_e, instance) => {
              // Use unique identifier for the product gallery
              const {
                src
              } = instance;
              $currentTarget.removeClass('is-loading')
              const $quickshop = $(src).find('.quick-shop');
              Shopify.theme.jsProduct.init($('.js-quick-shop'));
              $quickshop.addClass('quick-shop--loaded');
              $quickshop.addClass('content-loaded');
            },
            beforeClose: (_e, instance) => {
              // Use unique identifier for the product gallery
              const {
                src
              } = instance;
              const $quickshop = $(src).find('.quick-shop');
              $('body').removeClass('mobile-menu--opened');
              let lastScrollPosition = $('body').data('current-position');
              window.scrollTo(0, lastScrollPosition);
              $quickshop.removeClass('quick-shop--loaded');
              $quickshop.removeClass('content-loaded');
            }
          });
        }
      }).catch(error => console.error(e));
    });
  }

}

Shopify.theme.thumbnail = new ProductCard();
const videoEl = {
  playButtonIcon: '<button type="button" class="plyr__control plyr__control--overlaid" aria-label="Play, {title}" data-plyr="play"><svg class="play-icon-button-control" width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="60" height="60" fill="white"/><path fill-rule="evenodd" clip-rule="evenodd" d="M23 20V40L39 29.4248L23 20Z" fill="#323232"/></svg><span class="plyr__sr-only">Play</span></button>',
  playButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Play, {title}" data-plyr="play"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-pause"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-play"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Pause</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span></button>',
  muteButton: '<button type="button" class="plyr__controls__item plyr__control" aria-label="Mute" data-plyr="mute"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-muted"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-volume"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span></button>',
  progressInput: '<div class="plyr__controls__item plyr__progress__container"><div class="plyr__progress"><input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek"><progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress><span role="tooltip" class="plyr__tooltip">00:00</span></div></div>',
  volume: '<div class="plyr__controls__item plyr__volume"><input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume"></div>',
  fullscreen: '<button type="button" class="plyr__controls__item plyr__control" data-plyr="fullscreen"><svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-exit-fullscreen"></use></svg><svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-enter-fullscreen"></use></svg><span class="label--pressed plyr__tooltip" role="tooltip">Exit fullscreen</span><span class="label--not-pressed plyr__tooltip" role="tooltip">Enter fullscreen</span></button>'
};
const videoControls = `${videoEl.playButtonIcon}<div class="plyr__controls"> ${videoEl.playButton} ${videoEl.progressInput} ${videoEl.muteButton} ${videoEl.volume} ${videoEl.fullscreen}</div>`;
let videoPlayers = [];
let videosInRecommendedProductsPlayer;
Shopify.theme.video = {
  init: function () {
    this.setupVideoPlayer();
  },
  setupVideoPlayer: function () {
    const productVideos = document.querySelectorAll('[data-html5-video] video, [data-youtube-video]');
    let setupVideoPlayers = Plyr.setup(productVideos, {
      controls: videoControls,
      ratio: this.aspect_ratio,
      fullscreen: {
        enabled: true,
        fallback: true,
        iosNative: true
      },
      storage: {
        enabled: false
      }
    });
    let videoLooping = $('[data-video-loop]').data('video-loop') || false;
    $.each(setupVideoPlayers, function (index, player) {
      player.loop = videoLooping;
      videoPlayers.push(player);
    });
    this.setupListeners();
  },
  setupListeners: function () {
    // Adds plyr video id to video wrapper
    $.each(videoPlayers, function (index, player) {
      const id = player.id;
      let $video;

      if (player.isHTML5) {
        $video = $(player.elements.wrapper).find('video');
        $video.attr('data-plyr-video-id', id);
      } // When a video is playing, pause any other instances


      player.on('play', function (event) {
        var instance = event.detail.plyr;
        $.each(videoPlayers, function (index, player) {
          var playerID = player.id || player.media.dataset.plyrVideoId;

          if (instance.id != playerID) {
            player.pause();
          }
        });
      });
    });
  },
  enableVideoOnHover: function ($thumbnail) {
    var $html5Video = $thumbnail.find('[data-html5-video]');
    var $youtubeVideo = $thumbnail.find('[data-youtube-video]');
    var videoID;

    if ($html5Video.length > 0) {
      videoID = $html5Video.find('[data-plyr-video-id]').data('plyr-video-id');
    } else if ($youtubeVideo.length > 0) {
      videoID = $youtubeVideo.find('iframe').attr('id');
    }

    if (videoID) {
      $.each(videoPlayers, function (index, player) {
        if (player.id == videoID || player.media.id == videoID) {
          player.toggleControls(false);
          player.muted = true;
          player.play();
        }
      });
    }
  },
  disableVideoOnHover: function ($thumbnail) {
    var $html5Video = $thumbnail.find('[data-html5-video]');
    var $youtubeVideo = $thumbnail.find('[data-youtube-video]');
    var videoID;

    if ($html5Video.length > 0) {
      videoID = $html5Video.find('[data-plyr-video-id]').data('plyr-video-id');
    } else if ($youtubeVideo.length > 0) {
      videoID = $youtubeVideo.find('iframe').attr('id');
    }

    if (videoID) {
      $.each(videoPlayers, function (index, player) {
        if (player.id == videoID || player.media.id == videoID) {
          if (player.playing) {
            player.pause();
          }
        }
      });
    }
  }
};



  
$(document).ready(function() {

  if(Shopify.theme.jsProduct && Shopify.theme.jsProduct.is_pistol != false){
     Shopify.theme.jsProduct.pistolsCheckboxes();
     Shopify.theme.jsProduct.updateSummary();
  }
  
  // $('.custom-vertical-slider').fullpage({
  //       sectionSelector: '.shopify-section',
  //       navigation: true,
  //       slidesNavigation: true,
  //       controlArrows: false,
  //       scrollOverflow: true,
  //   resize: true,

  //     }); 
  $('body').on("click", function(){
    if($(".shipping_restrict_filter_dropdown.active").length > 0){
      if(!event.target.classList.contains('restrict__search') && !event.target.classList.contains('restrict_resultBox') && !event.target.classList.contains('restrict__dropdown__listelement')){
        $(".shipping_restrict_filter_dropdown.active").removeClass("active");
      }
    }
  });
  if($('body').scrollTop() > 100){
    $('.scroll--top-btn').addClass('active');  
  }
  $('.scroll--top-btn').on('click', function(){
    window.scrollTo({top: 0, behavior: 'smooth'});
  });
 
});

 $(document).ready(function() {
  $('.swatch__option').click(function() {
    let sellingPlanId = $(this).find('input')?.data('selling-plan');
    // if selling plan id is found, set the value of the input with name "selling_plan" to the selling plan id
    if (sellingPlanId){
      $('input[name="selling_plan"]').val(sellingPlanId);
    }
    setTimeout(function() {
      var selectedOptionValue = $('select[name="id"]').find(':selected').data('atc-text');
      if (!$('button[name="add"]').hasClass('disabled') && !$('button[name="add"]').prop('disabled')) {
        $('button[name="add"] span.text').text(selectedOptionValue);
      }
    }, 500); // 1-second timeout
  });
   if($(window).width() <= 768){
    $('.customer__account_blogs.custom-blogs .blogs--container').flickity({
      cellAlign: 'left',
      contain: true,
      draggable: true,
      freeScroll: true,
      prevNextButtons: false,
      pageDots: false
    });
     $('.customer__account_videos .vertical-slider-section-row > .container').flickity({
      cellAlign: 'left',
      contain: true,
      draggable: true,
      freeScroll: true,
      prevNextButtons: false,
      pageDots: false
    });
     if($('#back_top___btn').length > 0){
       document.getElementById('back_top___btn').scrollIntoView();   
     }
   $('#back_top___btn').on('click', function(){
      if($(this).closest('.dynamic-sections').find('.account-sidebar__content').length > 0){
       $(this).closest('.dynamic-sections').find('.account-sidebar__content').removeClass('account_mobile__hide__sidebar')
     }
     window.scrollTo({top: 0, behavior: 'smooth'});
   });
     if($(".mobile__slider__true").length > 0){
      $(".mobile__slider__true").flickity({
          lazyLoad: 2,
          freeScroll: false,
          imagesLoaded: true,
          draggable: true,
          cellAlign: 'center',
          adaptiveHeight: true,
          wrapAround: true,
          groupCells: true,
          pageDots: false,
          contain: true,
          prevNextButtons: true,
          initialIndex: 0
        });
    }
   }

  $(document).on("click", ".chat__launcher.button", function(){
    let chat_iframe = $('#launcher');
    //find button inside iframe
    let chat_button = chat_iframe.contents().find('.kZSTVM button');
    //trigger button click
    if(chat_button){
      chat_button.trigger("click");     
    }  
    
  });

   $(document).on('click', '.product-app .shopify-app-block .rebuy-widget.widget-type-dynamic-bundle .primary-title', function(){
    if($(this).hasClass('active')){
        $(this).removeClass('active');
        if($(this).siblings('.rebuy-bundle').length > 0){
          $(this).siblings('.rebuy-bundle').slideUp()
        }
        
    }
    else{
        $(this).addClass('active');
       if($(this).siblings('.rebuy-bundle').length > 0){
        $(this).siblings('.rebuy-bundle').slideDown()
       }
    }
  })

   
   $('.mobile_filter__btn').on('click', function(){
      if($(this).closest('.search__content').find('.sidebar-section').length > 0){
        if($(this).closest('.search__content').find('.sidebar-section').hasClass('active')){
          $(this).closest('.search__content').find('.sidebar-section').removeClass('active');
        }
        else{
           $(this).closest('.search__content').find('.sidebar-section').addClass('active');
        }
      }
   });

   $('.faceted_filtering_heading .close__mobile__filter').on('click', function(){
          $(this).closest('.sidebar-section').removeClass('active');
   });

    $(document).on('click','.rebuy-bundle__items .rebuy-product-options .rebuy-color-swatch .rebuy-color-input', function(){
      var color_name = $(this).val();
      if($(this).closest('.product__information').find('.product-block--product-options .products--options__values .product-item[data-value="'+color_name+'"]').length > 0){
          $(this).closest('.product__information').find('.product-block--product-options .products--options__values .product-item[data-value="'+color_name+'"]').click()
      }
    }); 

   if($('body').hasClass('page-warranty-registration')){
    (function($, window) {
        var adjustAnchor = function() {

            var $anchor = $(':target'),
                    fixedElementHeight = 300;

            if ($anchor.length > 0) {

                $('html, body')
                    .stop()
                    .animate({
                        scrollTop: $anchor.offset().top - fixedElementHeight
                    }, 200);

            }

        };

        $(window).on('hashchange load', function() {
            adjustAnchor();
        });

    })(jQuery, window);
   }

   if($(window).width() <= 1024){
        if($('.new_comparison__table_inner').length > 0){
        $('.new_comparison__table_inner').flickity({
          cellAlign: 'left',
          contain: true,
          draggable: true,
          freeScroll: false,
          prevNextButtons: false,
          pageDots: true
        });
       }
    }
   $(window).on('resize', function(event) {
     if($(window).width() <= 1024){
        if($('.new_comparison__table_inner').length > 0 && $('.new_comparison__table_inner.flickity-enabled').length == 0){
        $('.new_comparison__table_inner').flickity({
          cellAlign: 'left',
          contain: true,
          draggable: true,
          freeScroll: false,
          prevNextButtons: false,
          pageDots: true
        });
       }
    }
   });
});
 

// // jQuery code to handle image click and play the video
// $(document).ready(function () {
//   $('.image-wrapper').on('click', function () {
//     // Get the video iframe and its parent video block
//     var $videoBlock = $(this).closest('.video-block');
//     var $videoIframe = $videoBlock.find('iframe');

//     // Get the YouTube video ID from the image's data attribute
//     var youtubeVideoId = $(this).find('.thumbnail-img').data('video-id');

//     // Update the iframe source with the YouTube video ID
//     var newIframeSrc = 'https://www.youtube.com/embed/' + youtubeVideoId + '?enablejsapi=1&autoplay=1';
//     $videoIframe.attr('src', newIframeSrc);

//     // Hide the image and show the video block
//     $(this).hide();
//     $videoBlock.find('.plyr__video-embed').show();

//     // Play the video using YouTube's JavaScript API
//     var player = new YT.Player($videoIframe[0]);
//     player.playVideo();
//   });
// });


// function rebuy_atc() {
//   let interval_id = setInterval(rebuy_atc_btn, 1000);
//   function rebuy_atc_btn() {
//     let rebuy_atc_btns = document.querySelectorAll('.rebuy-button');
//     if (rebuy_atc_btns.length > 0) {
//       clearInterval(interval_id);
//       rebuy_atc_btns.forEach((rebuy_atc_btn)=> {
//         rebuy_atc_btn.addEventListener('click', (e)=>{
//           setTimeout(()=> {
//             fetch('/cart.js',{
//               'method': 'GET',
//             })
//             .then(getResponse =>{
//               return getResponse.json();      
//             })
//             .then(data=>{
//               let item_count = data.item_count;
//               let cart_items_total = `$${(data.total_price / 100).toFixed(2)}`
//               if(item_count > 0){
//                 let items = data.items;
//                 let current_item_html = "";
//                 for (let i=0; i<items.length; i++){

//                   // Product Options
//                   let product_options = '';
//                   if(items[i].options_with_values.length > 0){
//                     let options_with_values = items[i].options_with_values;
//                     console.log("options_with_values --->", options_with_values);
//                     for(let j=0; j<options_with_values.length; j++){
//                       if(options_with_values[j].value !='Default Title'){
//                        product_options += `<span>${options_with_values[j].name}:</span> <span>${options_with_values[j].value}</span><br>`; 
//                       }
//                     }
//                   }

                  
//                   current_item_html += `
//                   <div class="ajax-cart__product media" data-cart-item="${items[i].key}" data-line-item="${i+1}">
//                     <figure class="ajax-cart__product-image media-left">
//                       <a href="${items[i].url}">
//                         <img src="${items[i].featured_image.url}" alt="${items[i].featured_image.alt}">
//                       </a>
//                     </figure>
//                     <div class="ajax-cart__product-content media-content">
//                         <div class="ajax-cart__product-title is-h6">
//                             <a href="${items[i].url}">
//                                 ${items[i].title}
//                             </a>
//                         </div>
//                         <p class="item__properties is-text-small">${product_options}</p>
//                         <div class="ajax-cart__line-items">
//                         </div>
//                         <div class="ajax-cart__line-items-discount">
//                         </div>
//                         <div class="ajax-cart__price price is-h6">
//                             <span class="money">$${((items[i].price)/100).toFixed(2)}</span>
//                         </div>
//                         <div class="cart__quantity-drawer">
//                             <div class="ajax-cart__quantity-box product-quantity-box" data-line-item-key="${i+1}">
//                                 <label class="label is-sr-only" for="quantity">Qty</label>
//                                 <div class="quantity-wrapper quantity-style--box is-medium">
//                                     <span class="quantity-minus quantity-element button is-inverse" data-update-quantity="minus" disabled="">
//                                         <span class="icon" data-icon="minus"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="minus"><rect x="5" y="46" width="90" height="8"></rect></g></svg></span>
//                                     </span>
//                                     <div class="control quantity-input-control">
//                                         <input class="quantity-input quantity-element input" type="number" min="1" size="2" name="quantity" value="${items[i].quantity}" data-line-id="">
//                                     </div>
//                                     <span class="quantity-plus quantity-element button is-inverse" data-update-quantity="plus">
//                                         <span class="icon" data-icon="plus"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="plus"><polygon points="95 46 54 46 54 5 46 5 46 46 5 46 5 54 46 54 46 95 54 95 54 54 95 54 95 46"></polygon></g></svg></span>
//                                     </span>
//                                 </div>
//                             </div>
//                             <a class="ajax-cart__delete cart__remove-drawer" data-ajax-cart-delete="" data-cart-item-key="${items[i].key}" href="/cart/change?line=${i+1}&amp;quantity=0" title="Remove">
//                                 <button class="close" aria-label="close"><span class="icon" data-icon="c2_cart_remove"><svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>icons/31</title><g id="icons/31" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Bin"><rect id="Rectangle" x="0" y="0" width="22" height="22"></rect><g id="noun-bin-2025360" transform="translate(4.500000, 3.000000)" fill="#020122" fill-rule="nonzero"><path d="M12.1067602,2.30734962 L9.08007016,2.30734962 L9.08007016,0.690559766 C9.08007016,0.320031639 8.78242201,0 8.40192974,0 L4.58135377,0 C4.21748939,0 3.90321335,0.303099226 3.90321335,0.690559766 L3.90321335,2.30746992 L0.893062586,2.30735245 C0.396854354,2.30735245 0,2.71159503 0,3.21677043 L0,3.77256262 C0,3.97463278 0.148827028,4.12630871 0.347384157,4.12630871 L12.6526158,4.12630871 C12.8510519,4.12630871 13,3.97475609 13,3.77256262 L13,3.21677043 C12.9997692,2.71159503 12.6029094,2.30735245 12.1067011,2.30735245 L12.1067602,2.30734962 Z M5.25949419,1.36421719 L7.74038767,1.36421719 L7.74038767,2.30734962 L5.25949419,2.30734962 L5.25949419,1.36421719 Z" id="Shape"></path><path d="M11.6271208,5.03581408 L1.37276106,5.03581408 C1.24043198,5.03581408 1.14121691,5.15376654 1.14121691,5.28839878 L1.95167165,15.1410785 C1.98478272,15.6294418 2.38166365,16 2.86136213,16 L10.1386497,16 C10.61823,16 11.015232,15.6294719 11.0483402,15.1410785 L11.8587949,5.28839878 C11.8752926,5.15364624 11.7594617,5.03581408 11.6272508,5.03581408 L11.6271208,5.03581408 Z M4.9121691,13.7600672 L4.87905803,13.7600672 C4.58140988,13.7600672 4.33326147,13.5242826 4.31675171,13.2210571 L4.01910356,7.88208363 C4.00260592,7.56205199 4.23414977,7.29254692 4.54841991,7.27576488 C4.84606806,7.2589651 5.12735412,7.49474941 5.14383434,7.81477503 L5.44148249,13.1537485 C5.45798014,13.4737801 5.20993834,13.7432852 4.91216615,13.7600672 L4.9121691,13.7600672 Z M8.6831272,13.2211774 C8.66662955,13.5242766 8.41847198,13.7601875 8.12082088,13.7601875 L8.08770981,13.7601875 C7.77343377,13.7433878 7.54191324,13.4738854 7.55839346,13.1538688 L7.85604161,7.81489534 C7.87253926,7.4948637 8.13719477,7.25910315 8.45145605,7.27588518 C8.76571732,7.29266722 8.99725261,7.56218733 8.98077239,7.88220394 L8.6831272,13.2211774 Z" id="Shape"></path></g></g></g></svg></span></button>
//                             </a>
//                             <p class="ajax-cart__quantity-warning quantity-warning"></p>
//                         </div>
//                     </div>
//                     <div class="ajax-cart__right-content media-right">
//                         <a class="ajax-cart__delete" data-ajax-cart-delete="" data-cart-item-key="${items[i].key}" href="/cart/change?line=${i+1}&amp;quantity=0" title="Remove">
//                             <button class="close" aria-label="close"><span class="icon" data-icon="x"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="x"><polygon points="97.83 7.83 92.17 2.17 50 44.34 7.83 2.17 2.17 7.83 44.34 50 2.17 92.17 7.83 97.83 50 55.66 92.17 97.83 97.83 92.17 55.66 50 97.83 7.83"></polygon></g></svg></span></button>
//                         </a>
//                     </div>
//                 </div>`
//                 }

//                 let all_ajax_cart_drawer = document.querySelectorAll('.ajax-cart--drawer');
//                 let all_cart_icons = document.querySelectorAll('.header-cart__icon');

//                 all_ajax_cart_drawer.forEach((ajax_cart_drawer)=> {
                  
//                   // Removing empty cart message
//                   ajax_cart_drawer.querySelector('.ajax-cart__empty-cart-message').classList.add('is-hidden');

//                   // Updating Cart Count
//                   ajax_cart_drawer.querySelector('.ajax-cart__cart-count').querySelector('.cart__count--text').innerHTML = item_count;
  
//                   // Displaying cart item form
//                   ajax_cart_drawer.querySelector('.ajax-cart__form').style.cssText = "display: flex";
//                   ajax_cart_drawer.querySelector('.ajax-cart__form').classList.remove('is-hidden');
  
//                   // Updating total text
//                   ajax_cart_drawer.querySelector('.ajax-cart__subtotal').querySelector('.money').innerHTML = cart_items_total;
                  
//                   // Adding new items to cart
//                   ajax_cart_drawer.querySelector('.ajax-cart__list-items').innerHTML = current_item_html;
                  
//                 })

//                 c2Rocommendations(items[0].product_id);

//                 // Opening Cart Drawer
//                 all_cart_icons.forEach((cart_icon)=>{
//                     cart_icon.click();
//                 })
                
//               }
//             })
//           },3000)
//         })
//       })
//     }
//   }
// }

// rebuy_atc();



// fetch('/cart.js',{
//   'method': 'GET',
// })
// .then(getResponse =>{
//   return getResponse.json();      
// })
// .then(data=>{
//   let item_count = data.item_count;
//   let cart_items_total = `$${(data.total_price / 100).toFixed(2)}`;
  
//   if(item_count > 0){
//     let all_header_cart_count = document.querySelectorAll('.header-cart.action-area__link');
//     let items = data.items;
//     let current_item_html = "";
    
//     all_header_cart_count.forEach((header_cart_count)=>{
//       header_cart_count.querySelector('.header-cart__count').innerHTML = item_count;
//      header_cart_count.classList.add('has-cart-count');
//     })
    
//     for (let i=0; i<items.length; i++){
//       let product_options = '';
//       if(items[i].options_with_values.length > 0){
//         let options_with_values = items[i].options_with_values;
//         console.log("options_with_values --->", options_with_values);
//         for(let j=0; j<options_with_values.length; j++){
//           if(options_with_values[j].value !='Default Title'){
//            product_options += `<span>${options_with_values[j].name}:</span> <span>${options_with_values[j].value}</span><br>`; 
//           }
//         }
//       }

      
//       current_item_html += `
//       <div class="ajax-cart__product media" data-cart-item="${items[i].key}" data-line-item="${i+1}">
//         <figure class="ajax-cart__product-image media-left">
//           <a href="${items[i].url}">
//             <img src="${items[i].featured_image.url}" alt="${items[i].featured_image.alt}">
//           </a>
//         </figure>
//         <div class="ajax-cart__product-content media-content">
//             <div class="ajax-cart__product-title is-h6">
//                 <a href="${items[i].url}">
//                     ${items[i].title}
//                 </a>
//             </div>
//             <p class="item__properties is-text-small">${product_options}</p>
//             <div class="ajax-cart__line-items">
//             </div>
//             <div class="ajax-cart__line-items-discount">
//             </div>
//             <div class="ajax-cart__price price is-h6">
//                 <span class="money">$${((items[i].price)/100).toFixed(2)}</span>
//             </div>
//             <div class="cart__quantity-drawer">
//                 <div class="ajax-cart__quantity-box product-quantity-box" data-line-item-key="${i+1}">
//                     <label class="label is-sr-only" for="quantity">Qty</label>
//                     <div class="quantity-wrapper quantity-style--box is-medium">
//                         <span class="quantity-minus quantity-element button is-inverse" data-update-quantity="minus" disabled="">
//                             <span class="icon" data-icon="minus"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="minus"><rect x="5" y="46" width="90" height="8"></rect></g></svg></span>
//                         </span>
//                         <div class="control quantity-input-control">
//                             <input class="quantity-input quantity-element input" type="number" min="1" size="2" name="quantity" value="${items[i].quantity}" data-line-id="">
//                         </div>
//                         <span class="quantity-plus quantity-element button is-inverse" data-update-quantity="plus">
//                             <span class="icon" data-icon="plus"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="plus"><polygon points="95 46 54 46 54 5 46 5 46 46 5 46 5 54 46 54 46 95 54 95 54 54 95 54 95 46"></polygon></g></svg></span>
//                         </span>
//                     </div>
//                 </div>
//                 <a class="ajax-cart__delete cart__remove-drawer" data-ajax-cart-delete="" data-cart-item-key="${items[i].key}" href="/cart/change?line=${i+1}&amp;quantity=0" title="Remove">
//                     <button class="close" aria-label="close"><span class="icon" data-icon="c2_cart_remove"><svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><title>icons/31</title><g id="icons/31" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g id="Bin"><rect id="Rectangle" x="0" y="0" width="22" height="22"></rect><g id="noun-bin-2025360" transform="translate(4.500000, 3.000000)" fill="#020122" fill-rule="nonzero"><path d="M12.1067602,2.30734962 L9.08007016,2.30734962 L9.08007016,0.690559766 C9.08007016,0.320031639 8.78242201,0 8.40192974,0 L4.58135377,0 C4.21748939,0 3.90321335,0.303099226 3.90321335,0.690559766 L3.90321335,2.30746992 L0.893062586,2.30735245 C0.396854354,2.30735245 0,2.71159503 0,3.21677043 L0,3.77256262 C0,3.97463278 0.148827028,4.12630871 0.347384157,4.12630871 L12.6526158,4.12630871 C12.8510519,4.12630871 13,3.97475609 13,3.77256262 L13,3.21677043 C12.9997692,2.71159503 12.6029094,2.30735245 12.1067011,2.30735245 L12.1067602,2.30734962 Z M5.25949419,1.36421719 L7.74038767,1.36421719 L7.74038767,2.30734962 L5.25949419,2.30734962 L5.25949419,1.36421719 Z" id="Shape"></path><path d="M11.6271208,5.03581408 L1.37276106,5.03581408 C1.24043198,5.03581408 1.14121691,5.15376654 1.14121691,5.28839878 L1.95167165,15.1410785 C1.98478272,15.6294418 2.38166365,16 2.86136213,16 L10.1386497,16 C10.61823,16 11.015232,15.6294719 11.0483402,15.1410785 L11.8587949,5.28839878 C11.8752926,5.15364624 11.7594617,5.03581408 11.6272508,5.03581408 L11.6271208,5.03581408 Z M4.9121691,13.7600672 L4.87905803,13.7600672 C4.58140988,13.7600672 4.33326147,13.5242826 4.31675171,13.2210571 L4.01910356,7.88208363 C4.00260592,7.56205199 4.23414977,7.29254692 4.54841991,7.27576488 C4.84606806,7.2589651 5.12735412,7.49474941 5.14383434,7.81477503 L5.44148249,13.1537485 C5.45798014,13.4737801 5.20993834,13.7432852 4.91216615,13.7600672 L4.9121691,13.7600672 Z M8.6831272,13.2211774 C8.66662955,13.5242766 8.41847198,13.7601875 8.12082088,13.7601875 L8.08770981,13.7601875 C7.77343377,13.7433878 7.54191324,13.4738854 7.55839346,13.1538688 L7.85604161,7.81489534 C7.87253926,7.4948637 8.13719477,7.25910315 8.45145605,7.27588518 C8.76571732,7.29266722 8.99725261,7.56218733 8.98077239,7.88220394 L8.6831272,13.2211774 Z" id="Shape"></path></g></g></g></svg></span></button>
//                 </a>
//                 <p class="ajax-cart__quantity-warning quantity-warning"></p>
//             </div>
//         </div>
//         <div class="ajax-cart__right-content media-right">
//             <a class="ajax-cart__delete" data-ajax-cart-delete="" data-cart-item-key="${items[i].key}" href="/cart/change?line=${i+1}&amp;quantity=0" title="Remove">
//                 <button class="close" aria-label="close"><span class="icon" data-icon="x"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g id="x"><polygon points="97.83 7.83 92.17 2.17 50 44.34 7.83 2.17 2.17 7.83 44.34 50 2.17 92.17 7.83 97.83 50 55.66 92.17 97.83 97.83 92.17 55.66 50 97.83 7.83"></polygon></g></svg></span></button>
//             </a>
//         </div>
//     </div>`
//     }

//     let all_ajax_cart_drawer = document.querySelectorAll('.ajax-cart--drawer');
//     let all_cart_icons = document.querySelectorAll('.header-cart__icon');

//     all_ajax_cart_drawer.forEach((ajax_cart_drawer)=> {
      
//       // Removing empty cart message
//       ajax_cart_drawer.querySelector('.ajax-cart__empty-cart-message').classList.add('is-hidden');

//       // Updating Cart Count
//       ajax_cart_drawer.querySelector('.ajax-cart__cart-count').querySelector('.cart__count--text').innerHTML = item_count;

//       // Displaying cart item form
//       ajax_cart_drawer.querySelector('.ajax-cart__form').style.cssText = "display: flex";
//       ajax_cart_drawer.querySelector('.ajax-cart__form').classList.remove('is-hidden');

//       // Updating total text
//       ajax_cart_drawer.querySelector('.ajax-cart__subtotal').querySelector('.money').innerHTML = cart_items_total;
      
//       // Adding new items to cart
//       ajax_cart_drawer.querySelector('.ajax-cart__list-items').innerHTML = current_item_html;
      
//     })

//     c2Rocommendations(items[0].product_id);

//     // Opening Cart Drawer
//     all_cart_icons.forEach((cart_icon)=>{
//         cart_icon.click();
//     })
//   }
// })







